import {
  useGetRootstocksWithVarietiesQuery,
  useGetVarietiesQuery,
} from 'common/api/endpoints/variety';
import { handleError } from 'common/api/utils/handleError';
import { DataTable, DataTableProps } from 'common/components/DataTable';
import {
  RootstocksTableRows,
  useRootstocksTableData,
  VarFormValues,
} from 'features/settings-view/hooks/useRootstocksTableData';
import { FC, useEffect, useState } from 'react';
import { AddRootstock } from './AddRootstock';
import { EditRootstockModal } from './EditRootstockModal';

export const Rootstocks: FC = () => {
  const [valuesToEdit, setValuesToEdit] = useState<VarFormValues | null>(null);

  const { data: varieties, error: varsError } = useGetVarietiesQuery();
  const {
    data: rootstocks,
    isLoading,
    isFetching,
    error: rootstocksError,
  } = useGetRootstocksWithVarietiesQuery();
  const formattedVarieties =
    varieties
      ?.toSorted((a, b) => a.varietyCode.localeCompare(b.varietyCode))
      .map(variety => ({
        id: variety.id,
        code: variety.varietyCode,
      })) || [];

  const { columns, data } = useRootstocksTableData(
    valuesToEdit,
    setValuesToEdit,
    rootstocks || [],
  );

  const tableProps: DataTableProps<RootstocksTableRows> = {
    columns,
    data,
    isLoading,
    isFetching,
    maxTableWidth: '800px',
    FooterComponent: valuesToEdit ? undefined : () => <AddRootstock />,
  };

  useEffect(() => {
    if (varsError) {
      handleError(varsError, 'Unable to fetch varieties.');
    }
  }, [varsError]);

  useEffect(() => {
    if (rootstocksError) {
      handleError(rootstocksError, 'Unable to fetch rootstocks.');
    }
  }, [rootstocksError]);

  return (
    <>
      <DataTable {...tableProps} />
      {valuesToEdit && (
        <EditRootstockModal
          valuesToEdit={valuesToEdit}
          setValuesToEdit={setValuesToEdit}
          varieties={formattedVarieties}
        />
      )}
    </>
  );
};
